import { createUseStyles } from 'react-jss';
import { ThemeProps } from '@styles/theme';

import { flex } from '@resources/mixins';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    expanded: {},
    notActive: {},
    mainWrapper: {
        height: '100%',
        padding: `${theme.spacing(4)}px ${theme.spacing(8)}px ${theme.spacing(8)}px`,
        [theme.down('desktop')]: {
            padding: `${theme.spacing(3)}px ${theme.spacing(5)}px ${theme.spacing(5)}px`,
        },
        [theme.down('tablet')]: {
            padding: theme.spacing(4),
        },
    },
    body: {
        display: 'flex',
        padding: `${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(10)}`,
    },
    noInfo: {
        color: theme.colors.grey_text,
    },
    tableActions: {
        ...flex('row', 'space-between', 'center'),
        padding: `0 ${theme.spacing(4)}`,
        marginBottom: theme.spacing(3),
        gap: theme.spacing(1.5),
        flexWrap: 'nowrap',
        [theme.down('tablet')]: {
            padding: 0,
            flexWrap: 'wrap',
        },
    },
    summaryPanel: {
        display: 'flex',
        flex: '1 1 22rem',
        maxWidth: '40rem',
        minWidth: 0,
        marginBottom: 0,
        [theme.down('tablet')]: {
            width: '100%',
        },
    },
    filters: {
        display: 'flex',
        alignItems: 'center',
        flex: '0 1 auto',
        justifyContent: 'flex-end',
        [theme.down('tablet')]: {
            width: '100%',
            justifyContent: 'flex-start',
        },
    },
    invite: {
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
    },
    button: {
        border: 'none',
        background: 'none',
        outline: 'none',
        padding: 0,
        height: 24,
        width: 24,

        '&:disabled': {
            opacity: .3,
        },

        '&:hover': {
            background: theme.colors.icon_background,
            borderRadius: theme.radius / 2,
            cursor: 'pointer',
        },
    },
    h4: {
        fontFamily: theme.font.secondary,
        fontSize: 20,
        lineHeight: 1.4,
        fontWeight: 'normal',
        color: theme.colors.black,
    },
    searchWrapper: {
        width: 260,
        marginRight: 0,
        [theme.down('tablet')]: {
            width: 'min(100%, 360px)',
            marginRight: 0,
        },
    },
    nameWrapper: {
        ...flex('row', 'center', 'center'),
    },
    expandIcon: {
        transformOrigin: 'center',
        transition: 'transform .2s ease',
        transform: 'rotate(90deg)',

        '&$expanded': {
            transform: 'rotate(-90deg)',
        },
    },
    downloadName: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    bodySubComponent: {
        display: 'flex',
        flexDirection: 'column',
        padding: `${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(10)}`,
    },
    descriptionWrapper: {
        padding: `${0}px ${theme.spacing(2)} ${theme.spacing(4)} ${theme.spacing(2)}`,
        flex: '18 0 18%',

    },
    header: {
        color: theme.colors.grey_text,
        fontSize: 16,
        fontFamily: theme.font.secondary,
        lineHeight: 1.25,
        paddingBottom: 10,
    },
    text: {
        color: theme.colors.black,
        lineHeight: 1.5,
        fontSize: 16,
        fontFamily: theme.font.primary,
    },
    downloadableContainer: {
        ...flex('column', 'space-between', ''),
        flexWrap: 'wrap',
        width: '100%',
        border: `1.5px solid ${theme.colors.grey_light}`,
        minHeight: 'calc(100dvh - 300px)',
        fallbacks: { minHeight: 'calc(100vh - 300px)' },
        background: theme.colors.white,
        borderRadius: theme.radius,
        padding: theme.spacing(5),
        paddingTop: theme.spacing(1),
        [theme.down('tablet')]: {
            padding: theme.spacing(3),
        },
    },
}));
